<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
      <vs-col vs-lg="7" vs-sm="7"> </vs-col>
      <vs-col
        vs-align="flex-end"
        vs-lg="5"
        vs-sm="5"
        class="m-0 p-0 flex justify-end items-end"
      >
        <ul class="demo-alignment pb-0" style="float: right">
          <li class="pl-4 border-0 border-solid border-grey">
            <i
              class="fas fa-file-download fa-2x cursor-pointer hover:text-primary"
              @click="exportHandler()"
            ></i>
          </li>
        </ul>
      </vs-col>
    </vs-row>
    <vx-card>
      <b-table
        ref="table"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="false"
        :busy.sync="isBusy"
        :items="checkinDay"
        :fields="columns"
        :per-page="perPage"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template
          v-for="(column, index) in columns.filter(
            (e) => e.optionField === true
          )"
          v-slot:[`head(${column.key})`]="data"
        >
          <div v-bind:key="index" style="text-align: center">
            {{ data.label }}
          </div>
        </template>

        <template
          v-for="(column, index) in columns.filter(
            (e) => e.optionField === true
          )"
          v-slot:[`cell(${column.key})`]="data"
        >
          <div v-bind:key="index" style="text-align: center">
            {{ data.value === "0" ? "" : "1" }}
          </div>
        </template>
      </b-table>
      <div class="mt-3 text-right">
        <vs-pagination
          :total="Math.ceil(totalRows / perPage)"
          :max="7"
          v-show="totalRows > perPage"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        />
        <div class="mt-3">
          {{ from | numFormat("0,0") }} to {{ to | numFormat("0,0") }} of
          {{ totalRows | numFormat("0,0") }} orders
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import Service from "@/services";
import XLSX from "xlsx";

export default {
  data: () => ({
    event: null,
    checkinDay: [],
    dayList: [],
    columns: [
      { label: "Name", key: "name", sortable: false },
      { label: "Ticket", key: "ticket", sortable: false },
      { label: "Role", key: "role", sortable: false },
      { label: "Type", key: "type", sortable: false },
    ],
    from: 1,
    to: 1,
    isBusy: false,
    currentPage: 1,
    perPage: 20,
    totalRows: 0,
  }),
  async created() {
    this.isBusy = true;
    await this.getEvent();
    await this.getCheckinDay();
    this.isBusy = false;
  },
  watch: {
    async currentPage(val, oldVal) {
      if (oldVal != val) {
        this.currentPage = val;
        this.isBusy = true;
        await this.getCheckinDay();
        this.isBusy = false;
      }
    },
  },
  methods: {
    async getEvent() {
      const result = await Service.Event.get(this.$route.query.e);
      this.event = result.data.event;
    },
    async getCheckinDay() {
      const queryObject = {
        event_id: this.event.event_id,
        currentPage: this.currentPage,
        perPage: this.perPage,
      };

      const queryString = Object.keys(queryObject)
        .map((key) => key + "=" + queryObject[key])
        .join("&");

      const result = await Service.Report.checkinReportDays(queryString);

      this.totalRows = result.data.total;
      this.from = result.data.from;
      this.to = result.data.to;
      this.perPage = parseInt(result.data.per_page);
      this.checkinDay = result.data.rows;

      if (result.data.day_list) this.dayList = result.data.day_list;
      if (this.dayList.length === 0) {
        this.columns.push({ label: "At", key: "at", sortable: false });
      } else {
        const daysColumns = this.dayList.map((e) => ({
          label: e.label,
          key: e.code,
          sortable: false,
          center: true,
          optionField: true,
        }));
        this.columns.push(...daysColumns);
      }
      this.$refs.table.refresh();
    },

    async exportHandler() {
      const queryObject = {
        event_id: this.event.event_id,
        currentPage: 1,
        perPage: 1000,
      };

      const queryString = Object.keys(queryObject)
        .map((key) => key + "=" + queryObject[key])
        .join("&");

      const result = await Service.Report.checkinReportDays(queryString);
      if (!result.data.rows || result.data.rows.length === 0) return;
      const resultMapped = result.data.rows.map((e) => {
        const result = {
          Name: e.name,
          Ticket: e.ticket,
          Role: e.role,
          Type: e.type,
        };

        if (this.dayList.length === 0) {
          result.At = e.at;
        } else {
          this.dayList.forEach((day) => {
            result[day.label] = e[day.code] === "0" ? "" : "1";
          });
        }

        return result;
      });
      const dataWS = XLSX.utils.json_to_sheet(resultMapped);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "check-in-day.xlsx");
      this.$vs.loading.close();
    },
  },
};
</script>
